import React, { Component } from "react";
import {
  Button,
  Container,
  Header,
  Segment,
  Form,
  Grid,
  List,
  Image,
  Icon,
  Divider,
} from "semantic-ui-react";
import { onFacebookClick, onInstagramClick, onWhatsClick } from "./../js";
import iconWhatsApp from "./../static/icons8-whatsapp.svg";
import iconFacebook from "./../static/icons8-facebook.svg";
import iconInstagram from "./../static/instagram.svg";

const options = [
  { key: "v", text: "Varais", value: "Varais" },
  { key: "r", text: "Redes de Proteção", value: "redes" },
];

const style = {
  marginTop: "10px",
  marginBottom: "10px",
  color: "black",
  onHover: {
    opacity: 0.7,
  },
};

export default class ContatoComponent extends Component {
  state = {
    name: "",
    email: "",
    message: "",
    responseMessage: "",
    loading: false,
  };

  handleChange(e, data) {
    console.log({ e, data });
    this.setState({ [e.target.id]: data.value });
  }

  clearResponseMessage() {
    setTimeout(() => {
      this.setState({ responseMessage: "" });
    }, 3000);
  }

  handleSubmit = async () => {
    this.setState({ loading: true });
    console.log({ state: this.state });

    const { name, email, message } = this.state;

    if (!name || !email || !message) {
      console.log("send failed, empty fields");
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("message", message);

    fetch("http://www.varaisalpha.com.br/phpmailer/sendMail.php", {
      method: "POST",
      mode: "no-cors",
      body: formData,
    }).then(async (response) => {
      console.log({ response });
      if (response.status >= 200 && response.status < 300) {
        const responseMessage = await response.text();
        console.log({ responseMessage });
        this.setState({ responseMessage });
      } else {
        this.setState({
          responseMessage:
            "Não foi possivel enviar o email no momento, tente novamente mais tarde.",
        });
      }

      this.setState({ loading: false }, this.clearResponseMessage());
    });
  };

  render() {
    return (
      <Segment vertical>
        <Container>
          <Grid divided inverted stackable>
            <Grid.Row columns={2}>
              <Grid.Column>
                <Header as="h3">Contato</Header>
                <Header as="h4">
                  Entre em contato agora mesmo e solicite uma visita ou
                  orçamento:
                </Header>
                {this.state.responseMessage && (
                  <h4
                    style={{
                      border: "2px solid #eeeeee",
                      padding: "10px 20px",
                      color: "#0f3288",
                    }}
                  >
                    {this.state.responseMessage}
                  </h4>
                )}
                {this.state.loading ? (
                  <h3>Enviando sua mensagem... aguarde!</h3>
                ) : (
                  <Form loading={this.state.loading}>
                    <Form.Input
                      fluid
                      id="name"
                      label="Seu nome:"
                      placeholder=""
                      value={this.state.name}
                      onChange={(e, data) => {
                        e.persist();
                        this.handleChange(e, data);
                      }}
                    />
                    <Form.Input
                      id="email"
                      label="Seu e-mail:"
                      placeholder=""
                      value={this.state.email}
                      onChange={(e, data) => {
                        e.persist();
                        this.handleChange(e, data);
                      }}
                    />

                    <Form.TextArea
                      id="message"
                      label="Mais informações:"
                      placeholder="Digite aqui sua mensagem:"
                      value={this.state.message}
                      onChange={(e, data) => {
                        e.persist();
                        this.handleChange(e, data);
                      }}
                    />
                    <Button onClick={this.handleSubmit}>Enviar</Button>
                  </Form>
                )}
              </Grid.Column>
              <Grid.Column textAlign="left">
                <Header as="h4" content="Central de Atendimento" />
                <List link size="medium" verticalAlign="middle">
                  <List.Item style={style}>
                    <Image
                      as={Icon}
                      size="big"
                      name="phone"
                      className="rotate-icon"
                    />
                    <List.Content>{"(11) 4707-1958"}</List.Content>
                  </List.Item>
                  <List.Item style={style}>
                    <Image
                      as={Icon}
                      size="big"
                      name="phone"
                      className="rotate-icon"
                    />
                    <List.Content>{"(11) 9 9919-8944"}</List.Content>
                  </List.Item>
                </List>
                <Divider
                  as="h4"
                  className="header"
                  horizontal
                  style={{ margin: "3em 0em", textTransform: "uppercase" }}
                >
                  Redes Sociais
                </Divider>
                <List link size="medium" verticalAlign="middle">
                  <List.Item
                    as="a"
                    style={style}
                    onClick={() => onWhatsClick()}
                  >
                    {/* <Image as={Icon} size="massive" name="whatsapp square" /> */}
                    <Image
                      avatar
                      src={iconWhatsApp}
                      style={{
                        cursor: "pointer",
                        // marginLeft: 20,
                      }}
                      onClick={() => onWhatsClick()}
                    />
                    <List.Content>
                      {"Clique e fale com a gente no what's!!"}
                    </List.Content>
                  </List.Item>

                  <List.Item
                    as="a"
                    style={style}
                    onClick={() => onFacebookClick()}
                  >
                    <Image
                      avatar
                      src={iconFacebook}
                      style={{
                        cursor: "pointer",
                      }}
                    />
                    <List.Content>{"Facebook"}</List.Content>
                  </List.Item>

                  <List.Item
                    as="a"
                    style={style}
                    onClick={() => onInstagramClick()}
                  >
                    <Image
                      avatar
                      src={iconInstagram}
                      style={{
                        cursor: "pointer",
                        width: 22,
                        height: 22,
                        marginLeft: 3,
                        marginRight: 3,
                        borderRadius: 0,
                      }}
                    />
                    <List.Content>{"Instagram"}</List.Content>
                  </List.Item>
                </List>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </Segment>
    );
  }
}
